import type { SxProps, Theme } from '@mui/material';
import type { Variants } from './JuicyTypography.tsx';

export const getTypographySx = (theme: Theme, variantStyle: Variants, sx?: SxProps<Theme>) => ({
  backgroundImage: variantStyle === 'green' ? theme.palette.juicy_green_grad : theme.palette.juicy_orange_grad,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
  ...sx,
});